var scope_0 = require('/home/rwieruch/Websites/blog_robinwieruch/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1b3b5a40731f30156e81c0f8c4099ca8.js').default;
var scope_1 = require('/home/rwieruch/Websites/blog_robinwieruch/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1f347dd0e829f539e7ad270a7092774d.js').default;
var scope_2 = require('/home/rwieruch/Websites/blog_robinwieruch/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/523cf8eb9109e884d0db8caaeb575a98.js').default;
var scope_3 = require('/home/rwieruch/Websites/blog_robinwieruch/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/548bc9642f1dd4b668fa7c1b1a30a83e.js').default;
var scope_4 = require('/home/rwieruch/Websites/blog_robinwieruch/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/725aed87e75c41e82c194fc0ecc3d69f.js').default;
var scope_5 = require('/home/rwieruch/Websites/blog_robinwieruch/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ce6e76fdbd90a8a464894c16008a7c61.js').default;
var scope_6 = require('/home/rwieruch/Websites/blog_robinwieruch/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e73561318a733cf5dee24d83d671c0e5.js').default;
var scope_7 = require('/home/rwieruch/Websites/blog_robinwieruch/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_8 = require('/home/rwieruch/Websites/blog_robinwieruch/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f6bd0abb831c1314ee68da5bd9158e51.js').default;
var scope_9 = require('/home/rwieruch/Websites/blog_robinwieruch/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/fb1ad745d070738b4af872c202b231d9.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9 )
    